"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Navigation: true
};
exports.Navigation = void 0;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _LinkList = require("./link-list/LinkList");
var _yordex = require("../../assets/logos/yordex.svg");
var _config = require("./config");
Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _config[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});
var _navigationModule = _interopRequireDefault(require("./navigation.module.scss"));
var _LanguageSelector = require("../language-selector/LanguageSelector");
var CustomLogo = function CustomLogo(_ref) {
  var logoUrl = _ref.logoUrl;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    customImageLoaded = _useState2[0],
    setCustomImageLoaded = _useState2[1];
  (0, _react.useEffect)(function () {
    var image = new Image();
    image.onload = function () {
      setCustomImageLoaded(true);
    };
    image.onerror = function () {
      setCustomImageLoaded(true);
    };
    image.src = logoUrl;
    return function () {
      image.onload = null;
    };
  }, [logoUrl]);
  if (!customImageLoaded) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _navigationModule.default['navigation__custom-logo']
    });
  }
  return /*#__PURE__*/_react.default.createElement("img", {
    className: _navigationModule.default['navigation__custom-logo'],
    src: logoUrl,
    "data-testid": "custom-logo"
  });
};
var Navigation = function Navigation(_ref2) {
  var categories = _ref2.categories,
    tasksCount = _ref2.tasksCount,
    invoicesCount = _ref2.invoicesCount,
    traderSlug = _ref2.traderSlug,
    logoUrl = _ref2.logoUrl,
    traderSelect = _ref2.traderSelect;
  var wrapperRef = _react.default.useRef();
  var _useState3 = (0, _react.useState)(categories),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    navCategories = _useState4[0],
    setNavCategories = _useState4[1];
  var _getCategoryTypesObje = (0, _config.getCategoryTypesObject)(navCategories),
    primaryCategories = _getCategoryTypesObje.primaryCategories,
    secondaryCategories = _getCategoryTypesObje.secondaryCategories,
    tabletCategories = _getCategoryTypesObje.tabletCategories,
    mobileCategories = _getCategoryTypesObje.mobileCategories;
  var storedLanguage = localStorage.getItem('language');
  var defaultLanguage = 'EN';
  var selectedLanguage = storedLanguage || defaultLanguage;
  var handleClickOutside = function handleClickOutside(e) {
    if (wrapperRef && !wrapperRef.current.contains(e.target)) {
      setNavCategories(function (prevCategories) {
        return prevCategories.map(function (category) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, category), {}, {
            visible: false
          });
        });
      });
    }
  };
  var handleCategoryClick = function handleCategoryClick(e, id) {
    var targetIsAnchorLink = Boolean(e.target.href);
    setNavCategories(function (prevCategories) {
      return prevCategories.map(function (category) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, category), {}, {
          visible: !category.visible && category.id === id && !targetIsAnchorLink
        });
      });
    });
  };
  (0, _react.useEffect)(function () {
    setNavCategories((0, _config.setCategoryData)(categories, {
      tasksCount: tasksCount,
      invoicesCount: invoicesCount,
      traderSlug: traderSlug
    }));
  }, [tasksCount, invoicesCount, traderSlug, categories]);
  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: _navigationModule.default['navigation'],
    "aria-label": "Main menu",
    ref: wrapperRef
  }, logoUrl ? /*#__PURE__*/_react.default.createElement(CustomLogo, {
    logoUrl: logoUrl
  }) : /*#__PURE__*/_react.default.createElement(_yordex.ReactComponent, {
    className: _navigationModule.default['navigation__yordex-logo']
  }), traderSelect && /*#__PURE__*/_react.default.createElement("div", {
    className: _navigationModule.default['navigation__trader-select']
  }, traderSelect), /*#__PURE__*/_react.default.createElement(_LinkList.LinkList, {
    className: _navigationModule.default['primary-links'],
    categories: primaryCategories,
    onCategoryClick: handleCategoryClick
  }), /*#__PURE__*/_react.default.createElement(_LanguageSelector.LanguageSelector, {
    value: selectedLanguage,
    changeBackgroundColor: true,
    isNavigation: true
  }), /*#__PURE__*/_react.default.createElement(_LinkList.LinkList, {
    className: _navigationModule.default['secondary-links'],
    categories: secondaryCategories,
    onCategoryClick: handleCategoryClick
  }), /*#__PURE__*/_react.default.createElement(_LinkList.LinkList, {
    className: (0, _classnames.default)(_navigationModule.default['secondary-links'], _navigationModule.default['medium-size-links']),
    categories: tabletCategories,
    onCategoryClick: handleCategoryClick
  }), /*#__PURE__*/_react.default.createElement(_LinkList.LinkList, {
    className: (0, _classnames.default)(_navigationModule.default['small-size-links']),
    categories: mobileCategories,
    onCategoryClick: handleCategoryClick
  }));
};
exports.Navigation = Navigation;